import React, { ComponentProps } from 'react';
import Draggable from './Draggable';
require('styles/react-data-grid/react-data-grid-header.css');

const style: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  right: 0,
  width: 6,
  height: '100%',
};

const ResizeHandle = (props: Omit<ComponentProps<typeof Draggable>, 'className' | 'style'>) => {
  return <Draggable {...props} style={style} />;
};

export default ResizeHandle;
